// removed by extract-text-webpack-plugin
module.exports = {"BoxOne":"_3jVBe","BoxTwo":"_gUyqi","AmenitiesCategory":"_Q8NM0","SelectedAmenity":"_kpA74","Amenity":"_2u_dK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelAllAmenities/HotelAllAmenities.scss
// module id = 917
// module chunks = 0